import { Metric } from '@models';

export const metrics: { [key: string]: Metric } = {
  time: {
    value: 0,
    unit: 'Second',
    id: 'e1d9d427-7a2b-48bd-87a0-6d6dd42ab3fc',
  },
  needleDriverLeftPath: {
    value: 0,
    unit: 'Integer',
    id: '7a869a4d-5bca-4ef9-bc60-080d0701ec98',
  } as Metric,
  needleDriverRightPath: {
    value: 0,
    unit: 'Integer',
    id: '4bdd5706-2360-4e3b-ab8b-a2b19d3aee17',
  } as Metric,
};
